import { __extends } from "tslib";
import { release, somewhatImplemented, notImplemented } from '@awayfl/swf-loader';
import { axCoerceString } from '@awayfl/avm2';
import { Errors } from '@awayfl/avm2';
import { EventDispatcher } from '../events/EventDispatcher';
/**
 * Copyright 2014 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Class: Socket
var Socket = /** @class */ (function (_super) {
    __extends(Socket, _super);
    function Socket(host, port) {
        if (host === void 0) { host = null; }
        if (port === void 0) { port = 0; }
        var _this = _super.call(this, undefined) || this;
        host = axCoerceString(host);
        port = port | 0;
        return _this;
    }
    Object.defineProperty(Socket.prototype, "bytesAvailable", {
        // AS -> JS Bindings
        // _timeout: number /*uint*/;
        // _bytesAvailable: number /*uint*/;
        // _connected: boolean;
        // _objectEncoding: number /*uint*/;
        // _endian: string;
        // _bytesPending: number /*uint*/;
        get: function () {
            release || notImplemented('public flash.net.Socket::get bytesAvailable');
            return 0;
            // return this._bytesAvailable;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Socket.prototype, "connected", {
        get: function () {
            release || notImplemented('public flash.net.Socket::get connected');
            return false;
            // return this._connected;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Socket.prototype, "objectEncoding", {
        get: function () {
            release || notImplemented('public flash.net.Socket::get objectEncoding');
            return 0;
            // return this._objectEncoding;
        },
        set: function (version /*uint*/) {
            version = version >>> 0;
            release || notImplemented('public flash.net.Socket::set objectEncoding');
            // this._objectEncoding = version;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Socket.prototype, "endian", {
        get: function () {
            release || notImplemented('public flash.net.Socket::get endian');
            return '';
            // return this._endian;
        },
        set: function (type) {
            type = axCoerceString(type);
            release || notImplemented('public flash.net.Socket::set endian');
            // this._endian = type;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Socket.prototype, "bytesPending", {
        get: function () {
            release || notImplemented('public flash.net.Socket::get bytesPending');
            return 0;
            // return this._bytesPending;
        },
        enumerable: false,
        configurable: true
    });
    Socket.prototype.readBytes = function (bytes, offset, length) {
        if (offset === void 0) { offset = 0; }
        if (length === void 0) { length = 0; }
        bytes = bytes;
        offset = offset >>> 0;
        length = length >>> 0;
        release || notImplemented('public flash.net.Socket::readBytes');
        return;
    };
    Socket.prototype.writeBytes = function (bytes, offset, length) {
        if (offset === void 0) { offset = 0; }
        if (length === void 0) { length = 0; }
        bytes = bytes;
        offset = offset >>> 0;
        length = length >>> 0;
        release || notImplemented('public flash.net.Socket::writeBytes');
        return;
    };
    Socket.prototype.writeBoolean = function (value) {
        value = !!value;
        release || notImplemented('public flash.net.Socket::writeBoolean');
        return;
    };
    Socket.prototype.writeByte = function (value /*int*/) {
        value = value | 0;
        release || notImplemented('public flash.net.Socket::writeByte');
        return;
    };
    Socket.prototype.writeShort = function (value /*int*/) {
        value = value | 0;
        release || notImplemented('public flash.net.Socket::writeShort');
        return;
    };
    Socket.prototype.writeInt = function (value /*int*/) {
        value = value | 0;
        release || notImplemented('public flash.net.Socket::writeInt');
        return;
    };
    Socket.prototype.writeUnsignedInt = function (value /*uint*/) {
        value = value >>> 0;
        release || notImplemented('public flash.net.Socket::writeUnsignedInt');
        return;
    };
    Socket.prototype.writeFloat = function (value) {
        value = +value;
        release || notImplemented('public flash.net.Socket::writeFloat');
        return;
    };
    Socket.prototype.writeDouble = function (value) {
        value = +value;
        release || notImplemented('public flash.net.Socket::writeDouble');
        return;
    };
    Socket.prototype.writeMultiByte = function (value, charSet) {
        value = axCoerceString(value);
        charSet = axCoerceString(charSet);
        release || notImplemented('public flash.net.Socket::writeMultiByte');
        return;
    };
    Socket.prototype.writeUTF = function (value) {
        value = axCoerceString(value);
        release || notImplemented('public flash.net.Socket::writeUTF');
        return;
    };
    Socket.prototype.writeUTFBytes = function (value) {
        value = axCoerceString(value);
        release || notImplemented('public flash.net.Socket::writeUTFBytes');
        return;
    };
    Socket.prototype.readBoolean = function () {
        release || notImplemented('public flash.net.Socket::readBoolean');
        return false;
    };
    Socket.prototype.readByte = function () {
        release || notImplemented('public flash.net.Socket::readByte');
        return 0;
    };
    Socket.prototype.readUnsignedByte = function () {
        release || notImplemented('public flash.net.Socket::readUnsignedByte');
        return 0;
    };
    Socket.prototype.readShort = function () {
        release || notImplemented('public flash.net.Socket::readShort');
        return 0;
    };
    Socket.prototype.readUnsignedShort = function () {
        release || notImplemented('public flash.net.Socket::readUnsignedShort');
        return 0;
    };
    Socket.prototype.readInt = function () {
        release || notImplemented('public flash.net.Socket::readInt');
        return 0;
    };
    Socket.prototype.readUnsignedInt = function () {
        release || notImplemented('public flash.net.Socket::readUnsignedInt');
        return 0;
    };
    Socket.prototype.readFloat = function () {
        release || notImplemented('public flash.net.Socket::readFloat');
        return 0;
    };
    Socket.prototype.readDouble = function () {
        release || notImplemented('public flash.net.Socket::readDouble');
        return 0;
    };
    Socket.prototype.readMultiByte = function (length /*uint*/, charSet) {
        length = length >>> 0;
        charSet = axCoerceString(charSet);
        release || notImplemented('public flash.net.Socket::readMultiByte');
        return '';
    };
    Socket.prototype.readUTF = function () {
        release || notImplemented('public flash.net.Socket::readUTF');
        return '';
    };
    Socket.prototype.readUTFBytes = function (length /*uint*/) {
        length = length >>> 0;
        release || notImplemented('public flash.net.Socket::readUTFBytes');
        return '';
    };
    Socket.prototype.flush = function () {
        release || notImplemented('public flash.net.Socket::flush');
    };
    Socket.prototype.writeObject = function (object) {
        release || notImplemented('public flash.net.Socket::writeObject');
    };
    Socket.prototype.readObject = function () {
        release || notImplemented('public flash.net.Socket::readObject');
        return;
    };
    Socket.prototype.internalGetSecurityErrorMessage = function (host, port) {
        host = axCoerceString(host);
        port |= 0;
        release || somewhatImplemented('flash.net.Socket::internalGetSecurityErrorMessage');
        return 'SecurityErrorEvent';
    };
    Socket.prototype.internalConnect = function (host, port) {
        host = axCoerceString(host);
        port |= 0;
        release || somewhatImplemented('flash.net.Socket::internalConnect');
        this.sec.throwError('SecurityError', Errors.SocketConnectError, host, port);
    };
    Socket.prototype.didFailureOccur = function () {
        release || somewhatImplemented('flash.net.Socket::didFailureOccur');
        return true;
    };
    // Called whenever the class is initialized.
    Socket.classInitializer = null;
    // List of static symbols to link.
    Socket.classSymbols = null; // [];
    // List of instance symbols to link.
    Socket.instanceSymbols = null; // ["timeout", "timeout", "connect", "close"];
    return Socket;
}(EventDispatcher));
export { Socket };
